import topbar from 'topbar';

const Topbar = () => {
  const $document = $(document);
  const topbarConfig = {
    barThickness: 3,
    barColors: {
      '1.0': '#FFFFFF',
    },
    shadowBlur: 5,
    shadowColor: '#7527',
  };

  /**
   * Exibir loader
   */
  const show = () => {
    $document.trigger('ajaxStart');
  };

  /**
   * Esconder loader
   */
  const hide = () => {
    $document.trigger('ajaxStop');
  };

  /**
   * Adiciona configuração de apresentação de barra de carregamento / loader
   */
  const setup = () => {
    topbar.config(topbarConfig);
    $document.ajaxStop(topbar.hide);
    $document.ajaxStart(topbar.show);
    $document.on('hideLoader', topbar.hide);
    // @ts-ignore
    $document.on('showLoader', topbar.show);
  };

  setup();

  return {
    show,
    hide,
  };
};

const loader = {
  // TODO: Implementar loader em caso de uso

  getHtmlLoader: (type: string) => {
    switch (type) {
      case 'spin':
        return `
    <svg class="animate-spin  h-2.5 w-2.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>`;
    }
  },
  // getHtmlLoader: (type) => {
  //   const pulseBall = `<div class="ball-pulse d-block #classCustom#"><div class="ball-animated"></div><div class="ball-animated"></div><div class="ball-animated"></div></div>`;
  //   const ballClip = `<div class="ball-clip-rotate d-block #classCustom#"><div class="ball-animated"></div></div>`;
  //   switch (type) {
  //     case 'ball-pulse':
  //       return pulseBall.replace('#classCustom#', '');
  //     case 'ball-pulse-white':
  //       return pulseBall.replace('#classCustom#', 'white');
  //     case 'ball-clip-rotate':
  //       return ballClip.replace('#classCustom#', '');
  //     case 'ball-clip-rotate-white':
  //       return ballClip.replace('#classCustom#', 'white');
  //     default:
  //       return '';
  //   }
  // },
  topbar: Topbar(),
};

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, { loader }),
});

export default {};
